import React from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";

const Navigation = ({ menuItems, setClickSideMenu }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.data[0]);

  return (
    <nav>
      <ul>
        {menuItems.map((menu, index) => (
          <li key={index} className="dropdown">
            <Link
              to={menu.link || "/"}
              target={menu?.blank ? "_blank" : "_self"}
              onClick={() => {
                if (menu.action && typeof menu.action === "function") {
                  dispatch(menu.action(0));
                }
              }}>
              {menu.title}
            </Link>
            {menu.items && (
              <ul className="dropdown-menu">
                {menu.items.map(
                  (item, i) => (
                    <li key={i}>
                      <Link
                        to={item.link}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (menu.action && typeof menu.action === "function") {
                            dispatch(menu.action(i));
                          }
                          setClickSideMenu(false);
                        }}>
                        {item.label}
                      </Link>
                    </li>
                  ),
                  // ),
                )}
              </ul>
            )}
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navigation;
